import { RedBookData } from '../../../types/redbook';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const postSaveRedBookData = (
  constructPost: ConstructPost,
  data: RedBookData,
): Promise<NonPaginatedResponse<any> | undefined> =>
  constructPost<NonPaginatedResponse<any>>(
    `${PLUGIN_BASE_PATH}/red-book-request/save`,
    { data },
    { preventDefaultErrorToast: true },
  );
